<template>
  <div class="container">
    <!-- 面包屑 -->
    <div class="integralBreadcrumb">
      <div class="integralBreadcrumb-item"
           @click="routerHandle('myInfo')">个人中心</div>
      <div class="el-icon-arrow-right jt"></div>
      <div class="integralBreadcrumb-item"
           @click="routerHandle('demandManagement')">需求派单</div>
      <div class="el-icon-arrow-right jt"></div>
      <div class="integralBreadcrumb-item">{{demandId?'修改':'新增'}}</div>
    </div>
    <!-- 需求服务单信息 -->
    <el-form :inline="true"
             :model="dataForm"
             ref="dataForm"
             :rules="dataRule"
             @keyup.enter.native="getDataList()"
             label-width="120px"
             @submit.native.prevent>
      <div class="body-info"
           v-if="dataForm">
        <h2>需求服务单信息</h2>
        <el-form-item label="需求分类："
                      prop="demandTypeIds">
          <el-cascader v-model="dataForm.demandTypeIds"
                       :props="props"
                       :options="demandTypeList"></el-cascader>
        </el-form-item>
        <el-form-item label="联系人："
                      prop="contacts">
          <!-- <el-tooltip class="item" effect="dark" :content="username" placement="top-start" :disabled="(!dataForm.contacts) || dataForm.contacts.length===0"> -->
          <el-input maxlength="50"
                    v-model="username"
                    :disabled="true"
                    placeholder="请输入联系人"
                    clearable
                    style="width:210px;"></el-input>
          <!-- </el-tooltip> -->
        </el-form-item>
        <el-form-item label="手机号："
                      prop="contactNumber">
          <el-input v-model="mobile"
                    maxlength="50"
                    :disabled="true"
                    placeholder="请输入联系人手机号"
                    clearable
                    style="width:210px;"></el-input>
        </el-form-item>
        <el-form-item label="项目名称："
                      prop="projectName">
          <el-tooltip class="item"
                      effect="dark"
                      :content="dataForm.projectName"
                      placement="top-start"
                      :disabled="(!dataForm.projectName) || dataForm.projectName.length===0">
            <el-input v-model="dataForm.projectName"
                      maxlength="100"
                      placeholder="请输入项目名称"
                      clearable
                      style="width:210px;"></el-input>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="合同编号："
                      prop="equipmentSpecification">
          <el-input v-model="dataForm.contractCode"
                    maxlength="50"
                    placeholder="请输入合同编号"
                    clearable
                    style="width:210px;"></el-input>
        </el-form-item>
        <div>&nbsp;</div>
        <el-form-item label="服务场所："
                      prop="address">
          <el-select v-if="provinceList"
                     v-model="selectProvince"
                     placeholder="请选择省"
                     @change="handleProvinceChoose"
                     style="margin-right: 20px;">
            <el-option v-for="(item, index) in provinceList"
                       :key="index"
                       :label="item.name"
                       :value="`${item.name}%${item.codeP}`">
            </el-option>
          </el-select>
          <el-select :disabled="!selectProvince"
                     v-model="selectCity"
                     placeholder="请选择市"
                     @change="handleCityChoose"
                     style="margin-right: 20px;">
            <el-option v-for="(item, index) in cityList"
                       :key="index"
                       :label="item.name"
                       :value="`${item.name}%${item.codeC}`">
            </el-option>
          </el-select>
          <el-select :disabled="!selectCity"
                     v-model="selectArea"
                     placeholder="请选择区"
                     @change="handleAreaChoose">
            <el-option v-for="(item, index) in areaList"
                       :key="index"
                       :label="item.name"
                       :value="`${item.name}%${item.codeA}`">
            </el-option>
          </el-select>
          <br>
          <el-input type="textarea"
                    autosize
                    maxlength="200"
                    placeholder="请输入详细地址信息"
                    v-model="dataForm.address"
                    style="width: 900px; margin-top: 10px;"></el-input>
        </el-form-item>
        <div>&nbsp;</div>
        <el-form-item label="需求描述："
                      prop="demandDescribe">
          <el-input type="textarea"
                    maxlength="1000"
                    :autosize="{ minRows: 5}"
                    placeholder="请输入需求描述(如果需要联系其他人，则在此填上其他人的联系方式)"
                    v-model="dataForm.demandDescribe"
                    style="width:900px;"></el-input>
        </el-form-item>
        <div>&nbsp;</div>
        <el-form-item label="上传附件："
                      prop="remark">
          <el-upload :action="actionUrl"
                     :auto-upload="true"
                     :file-list="fileListC"
                     :headers="headerMsg"
                     :before-remove="removeFile"
                     :on-success="successFile"
                     :on-error="errorFile"
                     ref="upLoadFile"
                     :before-upload="beforeUpload">
            <div tabindex="0"
                 class="el-upload el-upload--picture-card">
              <i class="el-icon-plus"></i>
            </div>
            <div slot="tip"
                 class="el-upload__tip">上传文件不超过100MB</div>
          </el-upload>
          <!-- :http-request="uploadOss" -->
        </el-form-item>
      </div>
      <div class="row"
           style="display:flex;justify-content: center;">
        <button :class="'row-opt-but ' +(subLoading?'but-loading':'')"
                style="margin-right:10px;"
                @click="routerHandle()">
          <i class="el-icon-loading"
             v-if="subLoading"></i>
          取消
        </button>
        <button :class="'row-opt-but ' +(subLoading?'but-loading':'')"
                style="background-color:#1D65A8;color:#fff"
                @click="submitHandle()">
          <i class="el-icon-loading"
             v-if="subLoading"></i>
          确定
        </button>
      </div>
    </el-form>
  </div>
</template>
<script>
import { isMobile } from '@/utils/validate'
import Cookies from 'js-cookie'
//  const OSS = require('ali-oss')
export default {
  data () {
    var validateContacts = (rule, value, callback) => {
      if (!this.username) {
        callback(new Error('用户姓名不能为空，请修改个人信息'))
      } else {
        callback()
      }
    }
    var validateMobile = (rule, value, callback) => {
      if (!this.mobile) {
        callback(new Error('手机号不能为空，请修改个人信息'))
      } else if (!isMobile(this.mobile)) {
        callback(new Error('手机号格式错误'))
      } else {
        callback()
      }
    }
    var validateDemandTypeIds = (rule, value, callback) => {
      if (this.dataForm.demandTypeIds.length !== 2) {
        callback(new Error('需求分类不能为空'))
      } else {
        callback()
      }
    }
    var validateAddress = (rule, value, callback) => {
      if (!this.selectProvince) {
        callback(new Error('服务场所省份不能为空'))
      } else if (!this.selectCity) {
        callback(new Error('服务场所市不能为空'))
      } else if (!this.selectArea) {
        callback(new Error('服务场所区域不能为空'))
      } else {
        callback()
      }
    }
    return {
      actionUrl: `${window.SITE_CONFIG['forumURL']}/alioss/sysossali/aliOssUploadAttachment`,
      headerMsg: {
        token: Cookies.get('tokensp')
      },
      dataForm: {
        id: '',
        demandTypeId: '',
        contacts: '',
        contactNumber: '',
        userName: '',
        projectName: '',
        province: '',
        city: '',
        area: '',
        address: '',
        demandDescribe: '',
        demandOssRelationEntityList: [],
        contractCode: '',
        demandTypeIds: []
      },
      demandTypeList: [],
      props: {
        value: 'id',
        children: 'children',
        label: 'name'
      },
      fileListC: [], // 上传组件初始化数据
      fileListS: [], // 要提交的数据
      delUrls: [],
      selectProvince: '', // 选中的省份
      selectCity: '', // 选中的市份
      selectArea: '', // 选中的区
      provinceList: [],
      cityList: [],
      areaList: [],
      codeP: '',
      codeC: '',
      codeA: '',
      // oss参数
      bucketName: '',
      accessKeyId: '',
      accessKeySecret: '',
      stsToken: '',
      getAliTime: '', // 到期时间
      subLoading: false, // 按钮加载中
      subFlag: false, // 提交成功
      dataRule: {
        demandTypeIds: [
          { required: true, message: '需求分类不能为空', trigger: 'blur' },
          { validator: validateDemandTypeIds, trigger: 'blur' }
        ],
        contacts: [
          // { required: true, message: '联系人不能为空', trigger: 'blur' }
          { validator: validateContacts, trigger: 'blur' }
        ],
        contactNumber: [
          // { required: true, message: '联系电话不能为空', trigger: 'blur' },
          { validator: validateMobile, trigger: 'blur' }
        ],
        // projectName: [
        //   { required: true, message: '项目名称不能为空', trigger: 'blur' }
        // ],
        address: [
          { required: true, message: '地址', trigger: 'blur' },
          { validator: validateAddress, trigger: 'blur' }
        ],
        demandDescribe: [
          { required: true, message: '需求描述不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    demandId () {
      return this.$route.query.id
    },
    username () {
      return this.dataForm.contacts || this.$store.state.userInfo.username
    },
    mobile () {
      return this.dataForm.contactNumber || this.$store.state.userInfo.mobile
    }
    // allList () {
    //   console.log(this.$refs.upLoadFile.uploadFiles.length, 'this.$refs.upLoadFile.uploadFiles.length')
    //   return this.$refs.upLoadFile.uploadFiles.length
    // },
    // canSub () {
    //   return this.subLoading && allList === 0
    // }
  },
  watch: {
    demandId (val) {
      this.formatFormData()
      if (val) {
        this.getInfo()
      }
    }
  },
  created () {
    window.addEventListener('beforeunload', this.deleteOssId)
    this.getProvince()
    // this.getOssKey()
    this.getDemandTypeList()
    this.formatFormData()
    if (this.demandId) {
      this.getInfo()
    } else {
    }
  },
  methods: {
    formatFormData () {
      this.dataForm = {
        id: 0,
        demandTypeId: '',
        contacts: this.$store.state.userInfo.username,
        contactNumber: this.$store.state.userInfo.mobile,
        userName: '',
        projectName: '',
        province: '',
        city: '',
        area: '',
        address: '',
        demandDescribe: '',
        demandOssRelationEntityList: [],
        contractCode: '',
        demandTypeIds: []
      }
    },
    // 选中省
    handleProvinceChoose (value) {
      this.dataForm.province = this.selectProvince.slice(0, this.selectProvince.indexOf('%'))
      this.codeP = this.selectProvince.slice(this.selectProvince.indexOf('%') + 1)
      this.selectCity = ''
      this.cityList = null
      this.selectArea = ''
      this.areaList = null
      this.dataForm.area = ''
      this.dataForm.city = ''
      this.codeC = ''
      this.codeA = ''
      this.getCity()
    },
    // 选中市
    handleCityChoose (value) {
      this.dataForm.city = this.selectCity.slice(0, this.selectCity.indexOf('%'))
      this.codeC = this.selectCity.slice(this.selectCity.indexOf('%') + 1)
      this.selectArea = ''
      this.areaList = null
      this.dataForm.area = ''
      this.codeA = ''
      this.getArea()
    },
    // 选中区
    handleAreaChoose (value) {
      this.dataForm.area = this.selectArea.slice(0, this.selectArea.indexOf('%'))
      this.codeA = this.selectArea.slice(this.selectArea.indexOf('%') + 1)
    },
    // 获取省列表
    getProvince () {
      this.$http.get(`${window.SITE_CONFIG['forumURL']}/integral/sysprovince/provinceList`)
        .then(data => {
          if (data.result.code === 0) {
            this.provinceList = data.result.provinceList
          } else {
            this.$message.error(data.result.msg)
          }
        })
        .catch(error => {
          this.$message.error(error.response.data.message)
        })
    },
    // 获取市列表
    getCity () {
      this.$http.get(`${window.SITE_CONFIG['forumURL']}/integral/sysprovince/cityList/${this.codeP}`)
        .then(data => {
          if (data.result.code === 0) {
            this.cityList = data.result.cityList
          } else {
            this.$message.error(data.result.msg)
          }
        })
        .catch(error => {
          this.$message.error(error.response.data.message)
        })
    },
    // 获取区列表
    getArea () {
      this.$http.get(`${window.SITE_CONFIG['forumURL']}/integral/sysprovince/areaList/${this.codeC}`)
        .then(data => {
          if (data.result.code === 0) {
            this.areaList = data.result.areaList
          } else {
            this.$message.error(data.result.msg)
          }
        })
        .catch(error => {
          this.$message.error(error.response.data.message)
        })
    },
    // 获取需求分类列表
    getDemandTypeList () {
      this.$http.get(`${window.SITE_CONFIG['baseURL']}/demandpayment/demandtype/list`)
        .then(data => {
          if (data && data.result && data.result.code === 0) {
            this.demandTypeList = data.result.data
          } else {
            this.demandTypeList = []
          }
        })
        .catch(() => {
          this.demandTypeList = []
        })
    },
    // 获取数据
    getInfo () {
      this.$http.get(`${window.SITE_CONFIG['baseURL']}/demandpayment/demandlist/info`, {
        params: {
          id: this.demandId
        }
      })
        .then(data => {
          if (data && data.result && data.result.code === 0) {
            let fileListC = []
            // this.fileListC =
            data.result.data.ossFiles.forEach(item => {
              fileListC.push({
                fileType: item.fileType,
                objectName: item.objectName,
                name: item.fileName + '.' + item.fileType,
                ossId: item.id,
                save: true,
                status: 'success'
              })
            })
            this.fileListC = fileListC
            this.fileListS = [].concat(fileListC)
            // this.dataForm.demandTypeIds = data.result.data.superDemandTypeId ? [data.result.data.superDemandTypeId, data.result.data.demandTypeId] : []
            this.selectProvince = data.result.data.province
            this.selectCity = data.result.data.city
            this.selectArea = data.result.data.area
            this.dataForm = {
              id: data.result.id,
              demandTypeId: data.result.data.demandTypeId,
              contacts: data.result.data.contacts,
              contactNumber: data.result.data.contactNumber,
              userName: data.result.data.userName,
              projectName: data.result.data.projectName,
              province: data.result.data.province,
              city: data.result.data.city,
              area: data.result.data.area,
              address: data.result.data.address,
              demandDescribe: data.result.data.demandDescribe,
              demandOssRelationEntityList: [],
              contractCode: data.result.data.contractCode,
              demandTypeIds: data.result.data.superDemandTypeId ? [data.result.data.superDemandTypeId, data.result.data.demandTypeId] : []
            }
          } else {
          }
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },
    // 提交
    submitHandle () {
      if (this.subLoading) {
        return false
      }
      let _this = this
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.subLoading = true
          this.dataForm.demandOssRelationEntityList = this.fileListS.map(item => {
            return { aliOssId: item.ossId }
          })
          this.dataForm.id = this.demandId
          this.dataForm.contacts = this.username
          this.dataForm.contactNumber = this.mobile
          this.dataForm.demandTypeId = this.dataForm.demandTypeIds[1]
          this.$http.post(`${window.SITE_CONFIG['baseURL']}/demandpayment/demandlist/${this.demandId ? 'update' : 'save'}`, this.dataForm)
            .then((data) => {
              if (data && data.result && data.result.code === 0) {
                this.subFlag = true
                this.$message({
                  message: '新增成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    _this.subLoading = false
                    _this.$router.go(-1)
                  }
                })
              } else {
                this.$message.error(data.result.msg)
                this.subLoading = false
              }
            })
            .catch(err => {
              this.subLoading = false
              this.$message.error(err.msg || '保存需求失败')
            })
        }
      })
    },
    // 跳转页面,取消返回
    routerHandle (name, pName) {
      if (name) {
        this.$router.push({ name: name })
      } else {
        this.formatFormData()
        this.$router.go(-1)
      }
    },
    // 删除文件
    removeFile (file, fileList) {
      if (this.subLoading) {
        return false
      }
      if (file.ossId && file.save) {
        let index = this.fileListS.findIndex(item => {
          return item.ossId === file.ossId
        })
        if (index > -1) {
          this.delUrls.push(this.fileListS[index].ossId)
          this.fileListS.splice(index, 1)
        }
      } else if (file.uid) {
        let index = this.fileListS.findIndex(item => {
          return item.uid === file.uid
        })
        if (index > -1) {
          this.$http.post(`${window.SITE_CONFIG['forumURL']}/alioss/sysossali/deleteAliOss/${this.fileListS[index].ossId}`)
            .then(item => {
              this.fileListS.splice(index, 1)
            })
            .catch(error => {
            })
        }
      }
    },
    // 上传成功
    successFile (response, file, fileList) {
      if (response.result.code === 0) {
        this.fileListS.push({
          uid: file.uid,
          ossId: response.result.data.id,
          ossName: response.result.data.objectName,
          url: response.result.data.url
          // uploadId: checkpoint.uploadId
        })
        this.subLoading = false
      } else {
        // console.log(this.$refs.upLoadFile.onRemove(file, fileList), file)
        // file.onError(file)
        this.$refs.upLoadFile.abort(file) // upload: el-upload的ref值；file:File类型，file文件本身
        fileList.splice(fileList.indexOf(file), 1) // fileList: 文件列表，钩子函数中的fileList
        this.removeFile(file, fileList)
        this.$message.error(response.result.msg || '上传失败')
        this.subLoading = false
      }
    },
    // 上传失败
    errorFile (err, file, fileList) {
      this.subLoading = false
    },
    beforeUpload (file) {
      if (this.subLoading) {
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 100
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 100MB!')
        return false
      }
      let newName = file.name.slice(0, file.name.lastIndexOf('.'))
      let regx = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
      if (regx.test(newName)) {
      } else {
        this.$message.warning('文件名只能由数字、英文字母、汉字组成，不能有空格 + 《 》等特殊符号')
        return false
      }
    },
    // 获取OSS参数
    getOssKey () {
      this.$http.get(`${window.SITE_CONFIG['forumURL']}/alioss/sysossali/getAliOssToken`)
        .then(item => {
          if (item.result.code === 0) {
            this.bucketName = item.result.bucketName
            this.accessKeyId = item.result.accessKeyId
            this.accessKeySecret = item.result.accessKeySecret
            this.stsToken = item.result.securityToken
            this.getAliTime = new Date(item.result.expiration)
            // this.multipartUpload()
            // this.putBlob()
          } else {
            this.$message.error(item.result.msg)
          }
        })
        .catch(() => {
          this.subLoading = false
        })
    },
    // 上传
    async uploadOss (file) {
      try {
        if (this.subLoading) {
          return false
        }
        let timeStamp = new Date().getTime()
        let _this1 = this
        let oldObj = `demand/${timeStamp}/${file.file.name}`
        let objectName = oldObj.replace(/\+/g, '')
        this.subLoading = true
        if (this.getAliTime.getTime() < new Date().getTime()) {
          await this.getOssKey()
        }
        await new OSS({
          region: `oss-cn-hangzhou`,
          accessKeyId: `${this.accessKeyId}`,
          accessKeySecret: `${this.accessKeySecret}`,
          bucket: `${this.bucketName}`,
          stsToken: `${this.stsToken}`
        }).multipartUpload(`${objectName}`, file.file, {
          progress: async function (p, checkpoint) {
            // 断点记录点。 浏览器重启后无法直接继续上传，需用户手动触发进行设置。
            // console.log(p, checkpoint)
            _this1.progress = parseInt(p * 100)
            _this1.p = p
            // file.percentage(p)
            file.onProgress({ percent: parseInt(p * 100) })
            // e.percent
            // this.tempCheckpoint = checkpoint
            if (p === 1) {
              // console.log(p, checkpoint)
              _this1.getVideoOssId(objectName, file, checkpoint)
            }
          }
        })
      } catch (e) {
        this.subLoading = false
        // console.log(e)
        file.onError(file)
        this.$message.warning('上传失败，请重新上传')
      }
    },
    getVideoOssId (objectName, file, checkpoint) {
      this.$http.post(`${window.SITE_CONFIG['forumURL']}/alioss/sysossali/aliOssUploadDemandAttachment`, {
        objectName: objectName,
        fileName: file.file.name,
        fileSize: file.file.size.toString()
      })
        .then(data => {
          if (data.result && data.result.code === 0) {
            this.fileListS.push({
              uid: file.file.uid,
              ossId: data.result.aliOssId,
              ossName: objectName
              // uploadId: checkpoint.uploadId
            })
          } else {
            file.onError(file)
          }
          this.subLoading = false
        })
        .catch(() => {
          file.onError(file)
          this.subLoading = false
        })
    },
    // 页面关闭时清理OSS文件
    deleteOssId () {
      let deleteIds = []
      if (this.subFlag) {
        deleteIds = this.delUrls
      } else {
        deleteIds = this.fileListS.filter(item => {
          return !item.save
        }).map(item => {
          return item.ossId
        })
      }
      if (deleteIds.length) {
        deleteIds.forEach(item => {
          this.$http.post(`${window.SITE_CONFIG['forumURL']}/alioss/sysossali/deleteAliOss/${item}`)
        })
      }
      window.removeEventListener('beforeunload', this.deleteOssId)
    }
  },
  beforeDestroy () {
    this.deleteOssId()
  }
}
</script>
<style scoped>
.body-conent {
  margin: 20px 0;
}
.body-info h2 {
  font-size: 20px;
  color: #333333;
  margin-bottom: 40px;
}
.body-info {
  margin: 10px 0;
  width: 100%;
  padding: 40px 30px;
  background-color: #fff;
}
.row {
  display: flex;
  margin: 10px 0;
  line-height: 36px;
  font-size: 16px;
  margin-bottom: 20px;
}
.row-item {
  width: 350px;
  height: 36px;
}
.row-item-label {
  display: inline-block;
  width: 120px;
  text-align: right;
  font-size: 14px;
  color: #333;
}
.row-item-input {
  border: 1px solid #eee;
  padding-left: 10px;
}
.row-item-textarea {
  border: 1px solid #eee;
  padding-left: 10px;
  margin-left: 10px;
  width: 90%;
}
/* .row-item-select{
    width: 60%;
  } */
.row-opt-but {
  width: 161px;
  height: 50px;
  border: 1px solid #1d65a8;
  background-color: #fff;
  color: #1d65a8;
  font-size: 16px;
  line-height: 48px;
  text-align: center;
  cursor: pointer;
}
.row-opt-but:hover {
  background-color: #1d65a8;
  color: #fff;
}
.but-loading {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
